import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-267d8448"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "idCard-uploader" }
const _hoisted_2 = { class: "uf-idcard-uploader__btn" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idCard-uploader-btn-text" }, "请上传证件正面", -1))
const _hoisted_4 = { class: "uf-idcard-uploader__btn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idCard-uploader-btn-text" }, "请上传证件背面", -1))
const _hoisted_6 = {
  class: "uf-idcard-uploader__btn",
  style: {"width":"50%"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idCard-uploader-btn-text" }, "请上传证件照", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_uploader = _resolveComponent("van-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.onlyHeader)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_van_uploader, {
            modelValue: _ctx.headerFileList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.headerFileList) = $event)),
            "max-count": 1,
            class: "uf-idcard-uploader",
            "preview-size": "105",
            "image-fit": "contain",
            style: {"margin-right":"10px"},
            "after-read": _ctx.upload,
            deletable: !_ctx.disabled
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_van_icon, {
                  name: "plus",
                  class: "idCard-uploader-btn-icon"
                }),
                _hoisted_3
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "after-read", "deletable"]),
          _createVNode(_component_van_uploader, {
            modelValue: _ctx.backFileList,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.backFileList) = $event)),
            "max-count": 1,
            class: "uf-idcard-uploader",
            "preview-size": "105",
            "image-fit": "contain",
            deletable: !_ctx.disabled,
            "after-read": _ctx.upload
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_van_icon, {
                  name: "plus",
                  class: "idCard-uploader-btn-icon"
                }),
                _hoisted_5
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "deletable", "after-read"])
        ], 64))
      : (_openBlock(), _createBlock(_component_van_uploader, {
          key: 1,
          modelValue: _ctx.headerFileList,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.headerFileList) = $event)),
          "max-count": 1,
          class: "uf-idcard-uploader",
          "preview-size": "105",
          "image-fit": "contain",
          "after-read": _ctx.upload,
          deletable: !_ctx.disabled
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_van_icon, {
                name: "plus",
                class: "idCard-uploader-btn-icon"
              }),
              _hoisted_7
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "after-read", "deletable"]))
  ]))
}